<div style="height: 80vh">
  <mat-card appearance="outlined">{{ cardTitle }}</mat-card>
  <div [formGroup]="formGroupTermin">
    <mat-form-field>
      <mat-label i18n>
        {{ "MAIN_APP_PENDENZEN_TERMIN.status" | translate }}</mat-label
      >
      <mat-select
        (selectionChange)="selectedAdress($event)"
        formControlName="fldStatus"
        required
      >
        <mat-option *ngFor="let status of dbStatus" [value]="status.status">
          {{ status.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label i18n>{{
        "MAIN_APP_PENDENZEN_TERMIN.erinnerung" | translate
      }}</mat-label>
      <mat-select formControlName="fldErinnerung" required>
        <mat-option *ngFor="let remin of dbReminder" [value]="remin.minuten">
          {{ remin.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label i18n>{{
        "MAIN_APP_PENDENZEN_TERMIN.kategorien" | translate
      }}</mat-label>
      <mat-select multiple formControlName="fldKategorie">
        <mat-option *ngFor="let kate of dbKategorien" [value]="kate.id">
          {{ kate.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox class="cbInaktiv-margin" formControlName="fldPrivat">
      {{ "MAIN_APP_PENDENZEN_TERMIN.privat" | translate }}
    </mat-checkbox>

    <mat-form-field style="width: 100%">
      <mat-label i18n>{{
        "MAIN_APP_PENDENZEN_TERMIN.objekt" | translate
      }}</mat-label>
      <input
        type="text"
        placeholder="Objekt wählen"
        aria-label="Suche"
        matInput
        formControlName="fldObjekt"
        [matAutocomplete]="auto"
        required
      />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        [displayWith]="getObjektDesc"
        (optionSelected)="selectedSearchItem($event)"
      >
        <mat-option
          *ngFor="let objekt of filteredDescriptions | async"
          [value]="objekt"
        >
          {{ objekt.beschreibung }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field>
      <mat-label i18n>{{
        "MAIN_APP_PENDENZEN_TERMIN.adresse" | translate
      }}</mat-label>
      <mat-select
        (selectionChange)="selectedAdress($event)"
        formControlName="fldAdresse"
        placeholder="Adresse wählen"
      >
        <mat-option *ngFor="let adress of objectAddresses" [value]="adress">
          {{ adress.zusammenfassung }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-icon-button [disabled]="!objIsChoosed">
      <mat-icon (click)="addObjectAddress()">import_contacts</mat-icon>
    </button>

    <mat-form-field>
      <mat-label i18n>{{
        "MAIN_APP_PENDENZEN_TERMIN.titel" | translate
      }}</mat-label>
      <input matInput formControlName="fldTitel" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "MAIN_APP_PENDENZEN_TERMIN.ort" | translate }}</mat-label>
      <input matInput formControlName="fldOrt" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{
        "MAIN_APP_PENDENZEN_TERMIN.startTermin" | translate
      }}</mat-label>
      <input
        matInput
        [matDatepicker]="pickerStart"
        formControlName="fldStartDatum"
        required
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerStart"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input type="time" matInput formControlName="fldStartZeit" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{
        "MAIN_APP_PENDENZEN_TERMIN.endTermin" | translate
      }}</mat-label>
      <input
        matInput
        [matDatepicker]="pickerEnd"
        formControlName="fldEndDatum"
        required
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerEnd"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input type="time" matInput formControlName="fldEndZeit" />
    </mat-form-field>

    <mat-form-field
      style="width: 100%"
      *ngIf="!showUserGroups"
    >
      <mat-label>{{
        "MAIN_APP_PENDENZEN_TERMIN.zuständig" | translate
      }}</mat-label>
      <mat-select formControlName="fldMitarbeiter" multiple required>
        <mat-option
          *ngFor="let employe of dbMitarbeiter"
          [value]="employe.userID"
          >{{ getMitarbeiter(employe) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      style="width: 100%"
      *ngIf="showUserGroups"
    >
      <mat-label>{{
        "MAIN_APP_PENDENZEN_TERMIN.zuständig" | translate
      }}</mat-label>
      <mat-select formControlName="fldMitarbeiter" multiple required>
        <mat-optgroup label="Mitarbeiter">
          <mat-option
            *ngFor="let employe of dbMitarbeiter"
            [value]="employe.userID"
            >{{ getMitarbeiter(employe) }}
          </mat-option>
        </mat-optgroup>
        <mat-optgroup label="Gruppen">
          <mat-option
            *ngFor="let empGroup of dbGruppen"
            [value]="empGroup.id"
            >{{ empGroup.description }}</mat-option
          >
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{
        "MAIN_APP_PENDENZEN_TERMIN.notizen" | translate
      }}</mat-label>
      <textarea matInput formControlName="fldNotizen"></textarea>
    </mat-form-field>

    <mat-checkbox
      class="cbInaktiv-margin"
      *ngIf="nurMeinenTerminAktualisieren"
      formControlName="fldNurMeinenTermin"
      align="end"
    >
      {{ "MAIN_APP_PENDENZEN_TERMIN.nurMeinenTerminAktualisieren" | translate }}
    </mat-checkbox>

    <mat-dialog-actions align="end">
      <button mat-stroked-button type="button" mat-dialog-close>
        {{ "MAIN_APP_PENDENZEN_TERMIN.abbrechen" | translate }}
      </button>
      <button
        mat-stroked-button
        type="submit"
        matDialogClose="yes"
        (click)="save()"
        [disabled]="!formGroupTermin.valid"
      >
        {{ "MAIN_APP_PENDENZEN_TERMIN.speichern" | translate }}
      </button>
    </mat-dialog-actions>
    <mat-error *ngIf="hasError" i18n>{{ errormsg }}</mat-error>
  </div>
</div>
